var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamyanInMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 55,
    viewBox: "0 0 68 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78678 27.364C3.51862 63.8525 67.2743 63.8463 68 27.364C67.2682 -9.12439 3.51253 -9.11829 2.78678 27.364Z",
    fill: "#E7F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.368286 49.3429C0.752502 48.9709 65.5693 50.0626 65.4839 48.9648C65.5693 47.8609 0.746407 48.9587 0.368286 48.5806C-0.107414 48.5745 -0.137909 49.349 0.368286 49.3429Z",
    fill: "#2F3D60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3148 48.7091C41.6077 48.9469 43.0104 48.4468 43.8398 47.3369L55.5493 31.6815C56.6166 30.2544 56.3238 28.2663 54.8907 27.2234C53.4453 26.1744 50.7557 26.2964 49.6641 27.7357L37.7168 43.5313C36.5885 45.0194 36.9239 47.0441 38.4547 48.0443C38.8328 48.2882 39.8879 48.6298 40.3148 48.7091Z",
    fill: "#2F3D60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.8905 27.2234C53.4451 26.1744 50.7556 26.2964 49.6639 27.7357L38.7412 42.1774C39.9609 42.1713 41.3087 42.5433 42.8944 41.7322C45.5351 40.3844 45.0899 37.6826 47.3525 35.9506C48.3893 35.1578 50.103 34.4869 53.134 34.9199L55.5552 31.6876C56.6164 30.2605 56.3237 28.2663 54.8905 27.2234Z",
    fill: "url(#paint0_linear_39_29910)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1537 24.8626C60.0927 24.8443 60.0257 24.8382 59.9647 24.826L55.476 23.6367L52.5121 35.3462L56.8726 36.3891C56.9763 36.444 57.0861 36.4866 57.202 36.5171C58.7449 36.9075 60.6538 34.6143 61.471 31.3942C62.2883 28.1802 61.6967 25.2529 60.1537 24.8626Z",
    fill: "#75A2DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.476 23.6378C56.1956 27.9679 55.2138 31.8528 52.512 35.3473L16.292 37.6404L24.2629 4.69531L55.476 23.6378Z",
    fill: "#75A2DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7819 30.2732C31.2703 29.8707 33.4292 25.504 37.1677 26.2846C40.1012 26.8945 40.2598 29.9316 43.181 30.3525C46.1694 30.7794 47.4501 27.7666 50.9874 27.48C52.5974 27.3519 54.1221 27.8398 55.5187 28.6448C55.1345 31.0233 54.1343 33.2554 52.512 35.3534L16.2919 37.6465L21.1038 26.986C23.9153 29.7487 26.0925 30.4683 27.7819 30.2732Z",
    fill: "#6793C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5568 37.6648C10.057 36.5263 8.33411 27.9953 10.7087 18.6103C13.0832 9.22527 18.656 2.5402 23.1559 3.67874C27.6557 4.81727 29.3786 13.3483 27.004 22.7333C24.6294 32.1182 19.0566 38.8033 14.5568 37.6648Z",
    fill: "#6793C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7125 37.0854C13.755 36.8415 12.9195 36.2072 12.2242 35.1887C11.5168 34.1519 10.9862 32.7797 10.6507 31.1087C9.94329 27.5959 10.1689 23.2048 11.2972 18.7528C12.4255 14.3007 14.31 10.3305 16.6031 7.57388C17.6947 6.26266 18.8169 5.31127 19.9268 4.73799C21.0246 4.17691 22.0614 4.01225 23.0189 4.2501C23.9764 4.49405 24.8119 5.12831 25.5071 6.14679C26.2146 7.18357 26.7452 8.55577 27.0806 10.2268C27.3794 11.6966 27.5075 13.3188 27.4831 15.0326C27.4404 17.4172 25.3181 19.387 24.6594 21.979C23.9642 24.7356 24.7509 27.9069 23.5556 30.1207C22.8176 31.4807 22.0065 32.7126 21.1283 33.7616C20.0366 35.0728 18.9145 36.0242 17.8045 36.5975C16.7067 37.1647 15.6639 37.3294 14.7125 37.0854Z",
    fill: "url(#paint1_linear_39_29910)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_29910",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 18,
    height: 34
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7124 37.0854C13.7549 36.8415 12.9194 36.2072 12.2242 35.1887C11.5167 34.1519 10.9861 32.7797 10.6507 31.1087C9.94325 27.5959 10.1689 23.2048 11.2972 18.7528C12.4254 14.3007 14.3099 10.3305 16.603 7.57388C17.6947 6.26266 18.8168 5.31127 19.9268 4.73799C21.0246 4.17691 22.0613 4.01225 23.0188 4.2501C23.9763 4.49405 24.8118 5.12831 25.5071 6.14679C26.2145 7.18357 26.7451 8.55577 27.0805 10.2268C27.788 13.7396 27.5623 18.1307 26.4341 22.5827C25.3058 27.0348 23.4213 31.005 21.1282 33.7616C20.0366 35.0728 18.9144 36.0242 17.8045 36.5975C16.7067 37.1647 15.6638 37.3294 14.7124 37.0854Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_29910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1339 20.7231C17.0422 25.0288 19.0304 29.1698 22.5189 29.9565C25.9524 30.7372 29.5567 27.9623 30.6179 23.7786C31.6791 19.5949 29.8129 15.4844 26.4098 14.5879C22.9519 13.6792 19.2256 16.4236 18.1339 20.7231Z",
    fill: "#F2D594"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_39_29910",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 18,
    height: 34
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7124 37.0854C13.7549 36.8415 12.9194 36.2072 12.2242 35.1887C11.5167 34.1519 10.9861 32.7797 10.6507 31.1087C9.94325 27.5959 10.1689 23.2048 11.2972 18.7528C12.4254 14.3007 14.3099 10.3305 16.603 7.57388C17.6947 6.26266 18.8168 5.31127 19.9268 4.73799C21.0246 4.17691 22.0613 4.01225 23.0188 4.2501C23.9763 4.49405 24.8118 5.12831 25.5071 6.14679C26.2145 7.18357 26.7451 8.55577 27.0805 10.2268C27.788 13.7396 27.5623 18.1307 26.4341 22.5827C25.3058 27.0348 23.4213 31.005 21.1282 33.7616C20.0366 35.0728 18.9144 36.0242 17.8045 36.5975C16.7067 37.1647 15.6638 37.3294 14.7124 37.0854Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_39_29910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.701 20.796C17.8898 23.9917 18.64 26.8825 20.3415 27.2423C22.0187 27.6021 24.0007 25.3639 24.7875 22.2597C25.5742 19.1494 24.885 16.2769 23.2323 15.8317C21.5491 15.3804 19.5121 17.6003 18.701 20.796Z",
    fill: "#F7C021"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.630199 38.1875H17.3589V41.6089H0.630199V38.1875Z",
    fill: "#F0B937"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76584 38.1875H17.3589V41.6089H12.5653C11.0894 40.6697 9.75383 39.5109 8.76584 38.1875Z",
    fill: "#F2D594"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76595 38.1875C9.75394 39.5109 11.0895 40.6697 12.5654 41.6089H6.08253C4.97257 40.5904 3.98458 39.4438 3.14297 38.1875H8.76595Z",
    fill: "#F7C021"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.630344 41.9501H17.359C17.5481 41.9501 17.7006 41.7977 17.7006 41.6086V38.1872C17.7006 37.9982 17.5481 37.8457 17.359 37.8457H0.630344C0.441286 37.8457 0.28882 37.9982 0.28882 38.1872V41.6086C0.28882 41.7977 0.441286 41.9501 0.630344 41.9501ZM17.0175 41.2732H0.965775V38.5288H17.0175V41.2732Z",
    fill: "#F0B937"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.630199 41.6094H17.3589V45.0307H0.630199V41.6094Z",
    fill: "#F0B937"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76584 41.6094H17.3589V45.0307H12.5653C11.0894 44.0915 9.75383 42.9328 8.76584 41.6094Z",
    fill: "#F2D594"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76595 41.6094C9.75394 42.9328 11.0895 44.0915 12.5654 45.0307H6.08253C4.97257 44.0123 3.98458 42.8657 3.14297 41.6094H8.76595Z",
    fill: "#F7C021"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.630344 45.372H17.359C17.5481 45.372 17.7006 45.2195 17.7006 45.0305V41.6091C17.7006 41.42 17.5481 41.2676 17.359 41.2676H0.630344C0.441286 41.2676 0.28882 41.42 0.28882 41.6091V45.0305C0.28882 45.2195 0.441286 45.372 0.630344 45.372ZM17.0175 44.695H0.965775V41.9506H17.0175V44.695Z",
    fill: "#F0B937"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19789 45.0371H19.9266V48.4585H3.19789V45.0371Z",
    fill: "#F0B937"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 45.0371H19.9266V48.4585H15.133C13.6571 47.5193 12.3215 46.3544 11.3335 45.0371Z",
    fill: "#F2D594"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3336 45.0371C12.3216 46.3605 13.6572 47.5193 15.1331 48.4585H8.65016C7.5402 47.44 6.55221 46.2934 5.71059 45.0371H11.3336Z",
    fill: "#F7C021"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19785 48.7936H19.9265C20.1156 48.7936 20.2681 48.6412 20.2681 48.4521V45.0368C20.2681 44.8478 20.1156 44.6953 19.9265 44.6953H3.19785C3.00879 44.6953 2.85633 44.8478 2.85633 45.0368V48.4582C2.85633 48.6412 3.00879 48.7936 3.19785 48.7936ZM19.585 48.1167H3.53328V45.3723H19.585V48.1167Z",
    fill: "#F0B937"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.876 33.503L33.2347 45.7852L30.7228 48.1083L19.364 35.8261L21.876 33.503Z",
    fill: "#F0B937"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4038 39.4746L33.2402 45.7806L30.7276 48.1042L27.477 44.5853C27.1598 42.8655 27.105 41.103 27.4038 39.4746Z",
    fill: "#F2D594"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4039 39.4743C27.105 41.0965 27.1599 42.8651 27.4709 44.5911L23.0677 39.8341C23.0616 38.3277 23.2324 36.8213 23.5861 35.3516L27.4039 39.4743Z",
    fill: "#F7C021"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7215 48.4456C30.7337 48.6774 33.4171 46.0306 33.4659 46.0306C33.6062 45.9025 33.6123 45.689 33.4842 45.5488L22.1284 33.266C22.0065 33.1319 21.7808 33.1197 21.6466 33.2477L19.134 35.5713C18.9937 35.6994 18.9876 35.9129 19.1157 36.0531C19.3596 36.169 30.3799 48.5371 30.7215 48.4456ZM32.7584 45.7683L30.7459 47.6284L19.8475 35.8458L21.8601 33.9857L32.7584 45.7683Z",
    fill: "#F0B937"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6792 32.0485L25.0817 47.0508L22.0134 48.5647L14.6109 33.5624L17.6792 32.0485Z",
    fill: "#F0B937"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2806 39.3477L25.0801 47.0564L22.0124 48.5689L19.8901 44.2754C20.0853 42.5312 20.5305 40.8235 21.2806 39.3477Z",
    fill: "#F2D594"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2806 39.3481C20.5304 40.8178 20.0852 42.5316 19.8962 44.2697L17.0298 38.4577C17.4506 37.0123 18.0422 35.6157 18.7984 34.3105L21.2806 39.3481Z",
    fill: "#F7C021"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0125 48.9103C22.1771 48.8737 25.4034 47.3795 25.4034 47.166C25.568 46.8367 18.0178 32.1999 17.9874 31.9071C17.902 31.7425 17.7007 31.6693 17.536 31.7547L14.4684 33.2671C14.3037 33.3464 14.2306 33.5599 14.3159 33.7245L21.7197 48.7273C21.7685 48.8371 21.8905 48.9103 22.0125 48.9103ZM24.6288 46.8977L22.171 48.1113L15.0722 33.7184L17.5299 32.5048L24.6288 46.8977Z",
    fill: "#F0B937"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_29910",
    x1: 44.7304,
    y1: 29.9283,
    x2: 51.6387,
    y2: 44.0319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_29910",
    x1: 25.7318,
    y1: 22.4107,
    x2: 11.2885,
    y2: 18.7563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamyanInMedia);
export default __webpack_public_path__ + "static/media/HamyanInMedia.4aeb0c5218de3fc5418bfb2e43b4be5b.svg";
export { ForwardRef as ReactComponent };